// extracted by mini-css-extract-plugin
export var header = "header-module--header--eORMa";
export var isSticky = "header-module--is-sticky--QZ6bg";
export var menuContainer = "header-module--menu-container--Bm3HW";
export var stickyWrapper = "header-module--sticky-wrapper--nXpX7";